import { Indicator, Tooltip, UnstyledButton } from '@mantine/core'

import { NavLink, useLocation } from '@redwoodjs/router'

interface SidebarLinkProps {
  icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string
    }
  >
  label: string
  route: string
  notification?: boolean
  expanded: boolean
  matchExact?: boolean
  matchPrefix?: string
}

const SidebarLink = ({
  icon: Icon,
  label,
  route,
  notification = false,
  expanded,
  matchExact = false,
  matchPrefix,
}: SidebarLinkProps) => {
  const location = useLocation()
  const isActive = matchPrefix
    ? location.pathname === matchPrefix ||
      location.pathname.startsWith(`${matchPrefix}/`)
    : matchExact
    ? route === location.pathname
    : route.split('/')[1] === location.pathname.split('/')[1]

  return (
    <Tooltip
      key={label}
      label={label}
      position="right"
      transitionProps={{ duration: 0 }}
    >
      <Indicator
        color="orange"
        disabled={!notification}
        size={5}
        position="middle-end"
      >
        <NavLink
          to={route}
          className={`text-based flex h-8 flex-row items-center text-sm font-medium text-doubleNickel-gray-600 ${
            expanded
              ? 'min-w-[12rem] gap-2 transition-all duration-700 ease-in-out'
              : 'min-w-[2rem] transition-all duration-700 ease-in-out'
          } px-1.5`}
          activeClassName="rounded-md bg-white"
        >
          <Icon
            className={`h-3.5 w-3.5 fill-none ${
              isActive
                ? 'stroke-doubleNickel-brand-600'
                : 'stroke-doubleNickel-gray-600'
            }`}
          />
          {expanded && (
            <div
              className={`text-xs ${
                isActive
                  ? 'text-doubleNickel-brand-600'
                  : 'text-doubleNickel-gray-600'
              }`}
            >
              {label}
            </div>
          )}
        </NavLink>
      </Indicator>
    </Tooltip>
  )
}

export default SidebarLink
